import { Link } from 'react-router-dom';

const Body = () => {
    return (
        <div className="content" style={{ marginBottom: "130px" }}>

            <h1 style={{
                fontSize: "200px",
                marginBottom: "-30px"
            }}>
                <span style={{ textShadow: '0px 20px 0px #E8E8E7' }}>4</span>
                <span style={{ color: '#086ad8', textShadow: '0px 20px 0px #0869d826' }}>0</span>
                <span style={{ textShadow: '0px 20px 0px #E8E8E7' }}>4</span></h1>

            <h3 style={{
                fontSize: '38px',
                lineHeight: '48px',
                fontWeight: '500',
                marginBottom: '40px'
            }}>Opps! you’r on the wrong place.</h3>

            <p style={{
                fontSize: '20px',
                lineHeight: '32px',
                fontWeight: '400',
                marginBottom: '20px'
            }}>The page requested could not be found. This could be a spelling error <br/>
                in the URL or a removed page.</p>

            <div className="header-btn d-none d-xl-block">
                <Link className="btn" to="/">BACK TO HOME</Link>
            </div>
        </div>
    );
}

export default Body;